/**
 * Gets a cookie value by name, without needing a bulky third-party library.
 * @param {String} name
 */
export default function getCookieByName(name) {
  const map = document.cookie.split('; ').map(v => v.split('=').map(decodeURIComponent));
  return Object.fromEntries(map)[name];
}
